import axios from 'axios';

export function assertNever(x: never): never {
    throw new Error(`Unhandled case: ${JSON.stringify(x)}`);
}

export const AppErrorKind = {
    NETWORK: 'network',
    NOT_FOUND: 'not-found',
    UNAUTHORIZED: 'unauthorized',
    UNKNOWN: 'unknown',
} as const;

export type AppError =
    | { kind: typeof AppErrorKind.NETWORK }
    | { kind: typeof AppErrorKind.NOT_FOUND }
    | { kind: typeof AppErrorKind.UNAUTHORIZED }
    | { kind: typeof AppErrorKind.UNKNOWN; raw: unknown };

export const toAppError = (error: unknown): AppError => {
    if (axios.isAxiosError(error)) {
        if (!error.response) return { kind: AppErrorKind.NETWORK };
        if (error.response.status === 404) return { kind: AppErrorKind.NOT_FOUND };
        if (error.response.status === 401) return { kind: AppErrorKind.UNAUTHORIZED };
    }
    return { kind: AppErrorKind.UNKNOWN, raw: error };
};

export const AsyncStatus = {
    IDLE: 'idle',
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
} as const;

export type AsyncState<T> =
    | { status: typeof AsyncStatus.IDLE }
    | { status: typeof AsyncStatus.LOADING }
    | { status: typeof AsyncStatus.SUCCESS; data: T }
    | { status: typeof AsyncStatus.ERROR; error: AppError };
